import Sentry from './sentry'; // init Sentry en premier (inactif sans REACT_APP_SENTRY_DSN)
import './config'; // garde-fou : échoue en prod si les URLs backend ne sont pas configurées
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

function ErrorFallback() {
  return (
    <div style={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 24, gap: 12 }}>
      <div style={{ fontSize: 40 }} aria-hidden="true">🏐</div>
      <h2 style={{ margin: 0 }}>Oups, un souci est survenu</h2>
      <p style={{ color: '#666', maxWidth: 320 }}>L'équipe a été notifiée. Recharge la page pour réessayer.</p>
      <button onClick={() => window.location.reload()} style={{ padding: '10px 18px', borderRadius: 10, border: 'none', background: '#F5A623', color: '#1a1a1a', fontWeight: 700, cursor: 'pointer' }}>
        Recharger
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
